import BomSourceSerializer from 'eflex/serializers/bom-source';

export default class GepicsBomSourceSerializer extends BomSourceSerializer {}
